import { render, staticRenderFns } from "./Checkmark.vue?vue&type=template&id=0cf0b09e"
import script from "./Checkmark.vue?vue&type=script&lang=js"
export * from "./Checkmark.vue?vue&type=script&lang=js"
import style0 from "./Checkmark.vue?vue&type=style&index=0&id=0cf0b09e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports